export enum EnumTipoCicloFacturacion {
  Contratos = 1,
  Trades,
  Flexibilidad,
  Producto
}
